import { StatusLevel } from '@scaleaq/sitecontrol-lib';

/** Display order for status breakdowns (accordion headers, toolbar summary, etc.). */
export const STATUS_LEVEL_DISPLAY_ORDER: StatusLevel[] = [
  StatusLevel.Healthy,
  StatusLevel.Warning,
  StatusLevel.Error,
  StatusLevel.Critical,
];
